import React from 'react';
import studioProStep1 from '../../media/modal-initial-questions/studio-pro-step1.png';
import studioProStep2 from '../../media/modal-initial-questions/studio-pro-step2.png';
import studioStep1 from '../../media/modal-initial-questions/studio-step1.png';
import studioStep2 from '../../media/modal-initial-questions/studio-step2.png';

const HGImageStudio = ({ step, isProPlan }) => {
  const alt = 'Studio Pro';

  return (
    <>
      {isProPlan && step === 1 && (
        <img src={studioProStep1} alt={alt} />
      )}

      {isProPlan && step === 2 && (
        <img src={studioProStep2} alt={alt} />
      )}

      {!isProPlan && step === 1 && (
        <img src={studioStep1} alt={alt} />
      )}

      {!isProPlan && step === 2 && (
        <img src={studioStep2} alt={alt} />
      )}
    </>
  );
};

export default HGImageStudio;
